import { returnsDefaultDiscountByWeightSchema } from "@redotech/redo-model/rate-table/rate-table";
import * as z from "zod/v4";

export const getDefaultDiscountTables = {
  name: "getDefaultDiscountTables" as const,
  input: z.object({}),
  output: z.object({
    discountTables: z.array(returnsDefaultDiscountByWeightSchema),
  }),
};
